import { create } from "zustand";
import zukeeper from "zukeeper";

const useAppState = create(
  zukeeper((set) => ({
    country: { countryCode: "pending...", countryName: "pending..." },
    setCountry: (newCountry) => set({ country: newCountry }),

    supportedLanguages: [
      { languageCode: "es", visibleCode: "es", languageName: "Español", languageNumber: 0 },
      { languageCode: "en", visibleCode: "en", languageName: "English", languageNumber: 1 },
      { languageCode: "fr", visibleCode: "fr", languageName: "Français", languageNumber: 2 },
      { languageCode: "de-DE", visibleCode: "de", languageName: "Deutsch", languageNumber: 3 },
      { languageCode: "nl", visibleCode: "nl", languageName: "Nederland", languageNumber: 7 },
      { languageCode: "it", visibleCode: "it", languageName: "Italiano", languageNumber: 4 },
      { languageCode: "pt-PT", visibleCode: "pt", languageName: "Português", languageNumber: 5 },
      { languageCode: "pl", visibleCode: "pl", languageName: "Polski", languageNumber: 9 },
      { languageCode: "ro", visibleCode: "ro", languageName: "Română", languageNumber: 12 },
      { languageCode: "cs-CZ", visibleCode: "cz", languageName: "Česky", languageNumber: 14 },
      { languageCode: "hr", visibleCode: "hr", languageName: "Hrvatski", languageNumber: 46 },
    ],

    isMobile: false,
    setIsMobile: (newIsMobile) => set({ isMobile: newIsMobile }),
    displayMobileFilterModal: false,
    setDisplayMobileFilterModal: (newDisplayMobileFilterModal) => set({ displayMobileFilterModal: newDisplayMobileFilterModal }),

    searchResults: [], // these are the results after taking into account the users search string
    setSearchResults: (newSearchResults) => set({ searchResults: newSearchResults }),
    filterResults: [], // these are the results after taking into account the users selected filters
    setFilterResults: (newFilterResults) => set({ filterResults: newFilterResults }),
    sortResults: [], // these are the results after taking into account the users selected sort option
    setSortResults: (newSortResults) => set({ sortResults: newSortResults }),
    // resultsToRender: [], // these are the final results to display
    // setResultsToRender: (newResultsToRender) => set({ resultsToRender: newResultsToRender }),

    scrollbarWidth: 0,
    setScrollbarWidth: (width) => set({ scrollbarWidth: width }),
  }))
);

window.store = useAppState;

export default useAppState;
